export const COLUMNS = [
  {
    Header: "Case ID",
    accessor: "case_number",
  },
  {
    Header: "File Type",
    accessor: "extension",
  },
  {
    Header: "File Name",
    accessor: "title",
  },
  {
    Header: "Date Entered",
    accessor: "date_entered",
  },
  {
    Header: "Date Modified",
    accessor: "date_modified",
  },
  {
    Header: "Category",
    accessor: "category",
  },
  {
    Header: "Status",
    accessor: "poa_status",
  },
  {
    Header: "Background Color",
    accessor: "bg_color",
  },
  {
    Header: "Modified By",
    accessor: "modified_user_name",
  },
];